
export function apiUrl(path)
{
  if (window.$jBoard.config.custom_tenant_api_url) {
    return window.$jBoard.config.custom_tenant_api_url + "/api" + path;
  }

  return "/api" + path;
}
